<template>
  <div class="spinner"></div>
</template>

<script>
  export default {
    name: 'Loading',
  };
</script>

<style scoped>
  .spinner {
    margin: 20px auto;
    background: no-repeat center center;
    border-radius: 50%; /* Rounds out the halo */
    opacity: .7; /* Some subtle opacity to help blend with variable background colors */
    height: 64px;
    width: 64px;
    background: url("../../assets/images/spiffygif_64x64.gif");
  }
</style>



// WEBPACK FOOTER //
// Loading.vue?61c6aab6